<template>
  <div class="create-choice">
    <span class="title">营销目标</span>
    <span class="content">{{ contentArr[0] }}</span>
    <span class="title">营销场景</span>
    <span class="content">{{ contentArr[1] }}</span>
    <span class="title">推广方式</span>
    <span class="content">{{ contentArr[2] }}</span>
    <el-image
      class="icon"
      :src="require('@/assets/images/simulation/icon_edit.svg')"
      fit="fit"
      @click="handleBack"
    ></el-image>
  </div>
</template>

<script>
export default {
  props: {
    contentArr: Array,
  },
  methods: {
    handleBack() {
      this.$emit("onChange");
    },
  },
};
</script>

<style lang="less" scoped>
.create-choice {
  margin-bottom: 60px;
  padding: 12px 20px;
  width: 648px;
  height: 44px;
  border-radius: 4px;
  align-items: center;
  background-color: #f2f2f2;
  .title {
    margin-right: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #666;
  }
  .content {
    margin-right: 44px;
    line-height: 20px;
    font-weight: 500;
    font-size: 14px;
    color: #333;
  }
  .icon {
    float: right;
    margin-top: 3px;
    width: 16px;
    height: 16px;
    vertical-align: middle;
    cursor: pointer;
  }
}
</style>